import React from 'react'
import {
  SaveCancel,
  FormRow,
  LinkAdder
} from '../../../components'

const ContentOfficialSocial = () => {
  return (
    <div>
      <div className="lg:w-2/3">
        <form>
          <p className="text-lg font-bold mb-5 lg:mb-8">Social Media (Optional)</p>
          <FormRow>
            <LinkAdder
              prefix="facebook.com"
              label="Facebook"
              defaultState={true}
              defaultValue="peacegen_id"
            />
          </FormRow>
          <FormRow>
            <LinkAdder
              prefix="instagram.com"
              label="Instagram"
              defaultState={true}
              defaultValue="peacegen_id"
            />
          </FormRow>
          <FormRow>
            <LinkAdder
              prefix="youtube.com"
              label="Youtube"
              defaultState={true}
            />
          </FormRow>

          <hr className="hidden lg:block my-8 lg:my-10"/>

          <div className="mb-8 lg:mb-16">
            <LinkAdder className="mb-5" prefix="twitter.com" label="Twitter"/>
            <LinkAdder className="mb-5" prefix="linkedin.com" label="LinkedIn"/>
            <LinkAdder className="mb-5" prefix="medium.com" label="Medium"/>
            <LinkAdder className="mb-5" prefix="pinterest.com" label="Pinterest"/>
            <LinkAdder className="mb-5" prefix="" label="Other Link(s)"/>
          </div>

          <SaveCancel />
        </form>
      </div>
    </div>
  )
}

export { ContentOfficialSocial }